// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"954e4fcc","847":"4eee5415"}[chunkId] + ".chunk.css";
};